import React from 'react';
import {useFormikContext} from 'formik';
import {Button} from './styles';

interface Props {
  title: string;
}

const SubmitButton: React.FC<Props> = ({title}) => {
  const {handleSubmit} = useFormikContext();

  return (
    <Button onClick={handleSubmit} submit>
      {title}
    </Button>
  );
};

export default SubmitButton;
